import React, { useEffect, useState } from 'react'
import { Icon, Row, Col, Uploader, Message, ControlLabel } from 'rsuite'
import { isImageOrPdf, isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import InputForm from '../../../components/forms/input/InputForm'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import { isEmpty } from 'lodash-es'
import IncomeRecordFileTable from '../../incomeRecordWidget/IncomeRecordFileTable'

export default function ManageDurableArticlesForm({
  schema,
  loading,
  Controller,
  register,
  control,
  errors,
  setValue,
  getValues,
  setError,
  clearErrors,
  onPreview,
  onDownload,
  onDelete,
  manageTypeVal,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(schema)
  const [manageType, setManageType] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileTableData, setFileTableData] = useState(formSchema?.attachFiles?.values || [])

  const [deleteFileIds, setDeleteFileIds] = useState([])

  const defaultMaxFileSize = 5

  useEffect(() => {
    // console.log('manageTypeVal : ', manageTypeVal)
    setManageType(manageTypeVal)
  }, [manageTypeVal])

  // const setValueNullField = () => {
  //   for (const key in getValues()) {
  //     if (key != 'attachFiles' && key != 'note' && key != 'manageType') {
  //       setValue(key, null)
  //     }
  //   }

  //   clearErrors()
  // }

  const handleDeleteFileTable = (rowData) => {
    var fileIds = [...deleteFileIds]

    fileIds.push(rowData.id)

    setValue('deleteFileIds', fileIds)

    setDeleteFileIds(fileIds)

    let _fileTable = fileTableData?.filter((item) => item.id != rowData.id)
    setFileTableData(_fileTable)
  }

  deleteFileIds
  return (
    <>
      {/* <Panel loading={loading}> */}

      <Controller
        key={'deleteFileIds'}
        name={'deleteFileIds'}
        control={control}
        defaultValue={deleteFileIds}
        value={deleteFileIds}
      />

      <Row>
        <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {/* {formSchema.attachFiles.label} */}
          <ControlLabel>
            {requiredFiled(
              formSchema.attachFiles.validators,
              formSchema.attachFiles.label || 'เอกสารแนบประกอบ'
            )}
          </ControlLabel>
        </Col>
        <Col lg={18} md={18} sm={24} xs={24}>
          {!formSchema?.attachFiles?.disabled && (
            <>
              {/* <Message
                showIcon
                type="info"
                description={`ชนิดที่รองรับ : ${
                  formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                }`}
                style={{ marginBottom: 10 }}
              /> */}
              <ErrorMessage error={errors[formSchema.attachFiles.name]} />
              <Controller
                key={formSchema.attachFiles.name}
                name={formSchema.attachFiles.name}
                control={control}
                rules={isValidators(formSchema.attachFiles.validators)}
                defaultValue={''}
                render={(props) => {
                  return (
                    <Uploader
                      accept={formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'}
                      autoUpload={false}
                      disabled={formSchema.attachFiles.disabled}
                      fileListVisible={true}
                      listType="picture-text"
                      fileList={props.value || []}
                      multiple
                      onChange={(fileList) => {
                        if (isEmpty(fileList)) {
                          props.onChange(undefined)
                        } else {
                          let file = fileList[fileList.length - 1]

                          if (
                            file.blobFile.size >
                            (formSchema?.attachFiles?.fileSize || defaultMaxFileSize) * 1024 * 1024
                          ) {
                            notification.open('error', {
                              title: `ขนาดไฟล์เกิน ${formSchema.attachFiles.fileSize || defaultMaxFileSize} MB`,
                              duration: 5000,
                            })
                            return
                          }

                          if (isImageOrPdf(file.blobFile.type)) {
                            props.onChange(fileList)
                            setFileTypeError(false)
                          } else {
                            setFileTypeError(true)
                            notification.open('error', {
                              title:
                                'ชนิดที่รองรับ ' + formSchema.attachFiles.fileType ||
                                '.jpg, .jpeg, .png, .pdf',
                              duration: 5000,
                            })
                          }
                        }
                      }}
                      draggable
                    >
                      <div>
                        <Icon size="2x" icon="upload2" />
                        <small className="uploder__text"></small>
                        {`  อัปโหลดไฟล์ ชนิดที่รองรับ : ${
                          formSchema.attachFiles.fileType || '.jpg, .jpeg, .png, .pdf'
                        } , ขนาดไฟล์ไม่เกิน ${formSchema.attachFiles.fileSize || defaultMaxFileSize} MB`}
                      </div>
                    </Uploader>
                  )
                }}
              />
            </>
          )}
        </Col>
      </Row>

      <Row style={{ marginTop: 10 }}>
        <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}></Col>
        <Col lg={18} md={18} sm={24} xs={24}>
          {fileTableData?.length > 0 && (
            <IncomeRecordFileTable
              data={fileTableData}
              deleteable={true}
              onPreview={onPreview}
              onDownload={onDownload}
              onDelete={handleDeleteFileTable}
            />
          )}
        </Col>
      </Row>

      {/* ขาย แปรสภาพ	แลกเปลี่ยน*/}
      {(manageType?.includes('2') || manageType?.includes('5') || manageType?.includes('6')) && (
        <>
          <Row style={{ marginTop: 10 }}>
            <Col lg={6} md={6} sm={24} xs={24} style={{ fontWeight: 550, textAlign: 'right' }}>
              {formSchema.commetee}
            </Col>
          </Row>
          {formSchema.commeteeResponsinatorName && (
            <Row style={{ marginTop: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                {requiredFiled(
                  formSchema.commeteeResponsinatorName.disabled
                    ? []
                    : formSchema.commeteeResponsinatorName.validators,
                  formSchema.commeteeResponsinatorName.label + ' : '
                )}
              </Col>
              <Col lg={18} md={18} sm={24} xs={24}>
                {formSchema.commeteeResponsinatorName.disabled ? (
                  <span>{formSchema.commeteeResponsinatorName.value}</span>
                ) : (
                  <InputForm
                    schema={formSchema.commeteeResponsinatorName}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel
                  />
                )}
              </Col>
            </Row>
          )}

          <Row style={{ marginTop: 10 }}>
            <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {requiredFiled(
                formSchema.commeteeStaffName.disabled
                  ? []
                  : formSchema.commeteeStaffName.validators,
                formSchema.commeteeStaffName.label + ' : '
              )}
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              {formSchema.commeteeStaffName.disabled ? (
                <span>{formSchema.commeteeStaffName.value}</span>
              ) : (
                <InputForm
                  schema={formSchema.commeteeStaffName}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  hideLabel
                />
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: 10 }}>
            <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
              {requiredFiled(
                formSchema.commeteeCoordinatorName.disabled
                  ? []
                  : formSchema.commeteeCoordinatorName.validators,
                formSchema.commeteeCoordinatorName.label + ' : '
              )}
            </Col>
            <Col lg={18} md={18} sm={24} xs={24}>
              {formSchema.commeteeCoordinatorName.disabled ? (
                <span>{formSchema.commeteeCoordinatorName.value}</span>
              ) : (
                <InputForm
                  schema={formSchema.commeteeCoordinatorName}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  hideLabel
                />
              )}
            </Col>
          </Row>
        </>
      )}

      <Row style={{ marginTop: 10 }}>
        <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
          {requiredFiled(
            formSchema.note.disabled ? [] : formSchema.note.validators,
            formSchema.note.label + ' : '
          )}
        </Col>
        <Col lg={18} md={18} sm={24} xs={24}>
          {formSchema.note.disabled ? (
            <span>{formSchema.note.value}</span>
          ) : (
            <InputForm
              schema={formSchema.note}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              hideLabel
              rows={5}
              componentClass="textarea"
            />
          )}
        </Col>
      </Row>

      {/* {formSchema?.comments?.map((item) => {
        //ความเห็น
        return (
          <>
            <Row style={{ marginTop: 10 }}>
              <Col lg={6} md={6} sm={24} xs={24} style={{ textAlign: 'right' }}>
                <b>{item.label}</b>
              </Col>
              <Col lg={18} md={18} sm={24} xs={24}>
                <Message type="info" description={item.value} />
              </Col>
            </Row>
          </>
        )
      })} */}
      {/* </Panel> */}
    </>
  )
}
